export default function Terms() {
  return (
    <div data-testid="terms-page" className="pt-32 pb-24">
      <section className="max-w-[900px] mx-auto px-6 lg:px-12">
        <p className="label-overline text-zinc-500">Legal</p>
        <h1 className="font-serif text-5xl md:text-6xl tracking-tighter font-light mt-4">Terms of use.</h1>
        <p className="text-zinc-500 mt-2 text-sm">Last updated: December 2025</p>

        <div className="mt-12 space-y-8 text-zinc-700 leading-relaxed">
          <Section title="1. Acceptance">
            <p>By accessing egemodels.com you agree to these terms. If you do not agree, please do not use the site.</p>
          </Section>

          <Section title="2. Use of the site">
            <p>The site and its content (text, images, design) are owned by Ege Models or licensed to us. You may view and share content for personal, non-commercial purposes. Commercial use requires written permission.</p>
          </Section>

          <Section title="3. Submissions">
            <p>By submitting a contact form or model application you confirm the information is accurate and that you have the right to submit any photos provided. You retain ownership of submitted photos; you grant us a limited licence to view and evaluate them for the purpose of your application.</p>
          </Section>

          <Section title="4. No professional advice">
            <p>Information on this site is for general purposes only and does not constitute legal, financial, or career advice.</p>
          </Section>

          <Section title="5. Liability">
            <p>To the maximum extent permitted by law, Ege Models is not liable for indirect, incidental or consequential damages arising from use of the site.</p>
          </Section>

          <Section title="6. Governing law">
            <p>These terms are governed by the laws of the Netherlands. Any disputes will be subject to the exclusive jurisdiction of the courts of Rotterdam.</p>
          </Section>

          <Section title="7. Contact">
            <p>Questions about these terms: <a href="mailto:legal@egemodels.com" className="link-underline">legal@egemodels.com</a></p>
          </Section>
        </div>
      </section>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div>
      <h2 className="font-serif text-2xl mb-3 text-black">{title}</h2>
      {children}
    </div>
  );
}
